// TBODY.tsx
import { cn } from "helpers/classNames";
import React from "react";

interface Props extends React.HTMLAttributes<HTMLTableSectionElement> {}

const TBody: React.FC<Props> = (props) => {
  return (
    <tbody
      {...props}
      className={cn("divide-y divide-gray-200", props.className || "")}
    />
  );
};

export default TBody;
